import { defineComponent, ref, computed, toRef, resolveComponent, openBlock, createElementBlock, createBlock, withCtx, createElementVNode, mergeProps, normalizeClass, toDisplayString, createVNode, createTextVNode, renderSlot, normalizeProps, guardReactiveProps, createCommentVNode } from 'vue';
import { t as te, n as ne } from '../OrAutocompleteV3-508d99c0.js';
import { OrButtonV3 as script$1 } from '../or-button-v3/index.js';
import { OrModalV3 as script$2 } from '../or-modal-v3/index.js';
import { OrPopoverV3 as script$3, PopoverPlacement } from '../or-popover-v3/index.js';
import '@vueuse/core';
import '@onereach/styles/screens.json';
import '@onereach/styles/tailwind.config.json';
import 'lodash/get';
import 'lodash/isElement';
import '../or-error-v3/index.js';
import '../or-hint-v3/index.js';
import '../or-icon-button-v3/index.js';
import '../or-icon-v3/index.js';
import '../or-tooltip-v3/index.js';
import '../or-input-box-v3/index.js';
import '../or-input-v3/index.js';
import '../OrInlineInputV3-46210775.js';
import '../or-inline-input-box-v3/index.js';
import '../or-text-v3/index.js';
import '../or-label-v3/index.js';
import '../or-loader-v3/index.js';
import '../or-menu-item-v3/index.js';
import '../or-tag-input-v3/index.js';
import '../or-tags-v3/index.js';
import '../or-tag-v3/index.js';
import '@floating-ui/dom';
import '../or-bottom-sheet-v3/index.js';
import '../or-overlay-v3/index.js';
import '../or-teleport-v3/index.js';

const FilterPopover = [
// Layout
'layout-column',
// Box
'w-auto md:w-[352px]',
// Spacing
'px-0 md:px-md', 'py-0 md:py-md', 'gap-md'];
const FilterPopoverHeader = [
// Layout
'layout-row',
// Spacing
'gap-md',
// Typography
'typography-headline-3'];
const FilterPopoverFooter = [
// Layout
'layout-row-reverse',
// Spacing
'gap-md'];

var script = defineComponent({
  name: 'OrFilterPopover',
  components: {
    OrButton: script$1,
    OrModal: script$2,
    OrPopover: script$3
  },
  inheritAttrs: false,
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Filters'
    },
    applyLabel: {
      type: String,
      default: 'View Results'
    },
    resetLabel: {
      type: String,
      default: 'Reset All'
    },
    closeLabel: {
      type: String,
      default: 'Close'
    },
    trigger: {
      type: Object,
      default: undefined
    },
    placement: {
      type: String,
      default: () => PopoverPlacement.BottomStart
    },
    fallbackPlacement: {
      type: String,
      default: undefined
    },
    enableDesktopControls: {
      type: Boolean,
      default: false
    },
    offset: {
      type: [Number, Object, Function],
      default: 8
    }
  },
  emits: ['update:state', 'open', 'close', 'apply', 'reset'],
  expose: ['root', 'state', 'open', 'close', 'toggle'],
  setup(props, context) {
    // Refs & Styles
    const root = ref();
    const rootStyles = computed(() => ['or-filter-popover-v3', ...FilterPopover]);
    const headerStyles = computed(() => [...FilterPopoverHeader]);
    const footerStyles = computed(() => [...FilterPopoverFooter]);
    // State
    const {
      state,
      open,
      close,
      toggle
    } = te(toRef(props, 'isOpen'), context.emit);
    // Methods
    function apply() {
      context.emit('apply');
    }
    function reset() {
      context.emit('reset');
    }
    // Helpers
    const {
      isDesktop,
      isMobile
    } = ne();
    return {
      root,
      rootStyles,
      headerStyles,
      footerStyles,
      state,
      open,
      close,
      toggle,
      apply,
      reset,
      isDesktop,
      isMobile
    };
  }
});

const _hoisted_1 = {
  class: /*#__PURE__*/normalizeClass(['contents'])
};
const _hoisted_2 = {
  class: /*#__PURE__*/normalizeClass(['grow', 'truncate'])
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrButton = resolveComponent("OrButton");
  const _component_OrPopover = resolveComponent("OrPopover");
  const _component_OrModal = resolveComponent("OrModal");
  return openBlock(), createElementBlock("div", _hoisted_1, [_ctx.isDesktop ? (openBlock(), createBlock(_component_OrPopover, {
    key: 0,
    "is-open": _ctx.state === 'open',
    variant: 'popover',
    trigger: _ctx.trigger,
    placement: _ctx.placement,
    "fallback-placement": _ctx.fallbackPlacement,
    offset: _ctx.offset,
    "onUpdate:state": _cache[3] || (_cache[3] = $event => $event === 'open' ? _ctx.open() : _ctx.close())
  }, {
    default: withCtx(() => [createElementVNode("div", mergeProps(_ctx.$attrs, {
      ref: 'root',
      class: _ctx.rootStyles
    }), [createElementVNode("div", {
      class: normalizeClass(_ctx.headerStyles)
    }, [createElementVNode("div", _hoisted_2, toDisplayString(_ctx.title), 1 /* TEXT */), createVNode(_component_OrButton, {
      variant: 'link',
      onClick: _cache[0] || (_cache[0] = $event => _ctx.reset())
    }, {
      default: withCtx(() => [createTextVNode(toDisplayString(_ctx.resetLabel), 1 /* TEXT */)]),
      _: 1 /* STABLE */
    })], 2 /* CLASS */), renderSlot(_ctx.$slots, "default"), renderSlot(_ctx.$slots, 'actions', normalizeProps(guardReactiveProps({
      apply: _ctx.apply,
      reset: _ctx.reset,
      isDesktop: _ctx.isDesktop,
      isMobile: _ctx.isMobile
    })), () => [_ctx.enableDesktopControls ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass(_ctx.footerStyles)
    }, [createVNode(_component_OrButton, {
      class: normalizeClass(['grow']),
      variant: 'contained',
      onClick: _cache[1] || (_cache[1] = $event => _ctx.apply())
    }, {
      default: withCtx(() => [createTextVNode(toDisplayString(_ctx.applyLabel), 1 /* TEXT */)]),
      _: 1 /* STABLE */
    }), createVNode(_component_OrButton, {
      class: normalizeClass(['grow']),
      variant: 'outlined',
      onClick: _cache[2] || (_cache[2] = $event => _ctx.close())
    }, {
      default: withCtx(() => [createTextVNode(toDisplayString(_ctx.closeLabel), 1 /* TEXT */)]),
      _: 1 /* STABLE */
    })], 2 /* CLASS */)) : createCommentVNode("v-if", true)])], 16 /* FULL_PROPS */)]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["is-open", "trigger", "placement", "fallback-placement", "offset"])) : createCommentVNode("v-if", true), _ctx.isMobile ? (openBlock(), createBlock(_component_OrModal, {
    key: 1,
    "is-open": _ctx.state === 'open',
    "onUpdate:state": _cache[6] || (_cache[6] = $event => $event === 'open' ? _ctx.open() : _ctx.close())
  }, {
    header: withCtx(() => [createTextVNode(toDisplayString(_ctx.title), 1 /* TEXT */)]),
    footer: withCtx(() => [renderSlot(_ctx.$slots, 'actions', normalizeProps(guardReactiveProps({
      apply: _ctx.apply,
      reset: _ctx.reset,
      isDesktop: _ctx.isDesktop,
      isMobile: _ctx.isMobile
    })), () => [createElementVNode("div", {
      class: normalizeClass(_ctx.footerStyles)
    }, [createVNode(_component_OrButton, {
      class: normalizeClass(['grow']),
      variant: 'contained',
      onClick: _cache[4] || (_cache[4] = $event => _ctx.apply())
    }, {
      default: withCtx(() => [createTextVNode(toDisplayString(_ctx.applyLabel), 1 /* TEXT */)]),
      _: 1 /* STABLE */
    }), createVNode(_component_OrButton, {
      class: normalizeClass(['grow']),
      variant: 'outlined',
      onClick: _cache[5] || (_cache[5] = $event => _ctx.reset())
    }, {
      default: withCtx(() => [createTextVNode(toDisplayString(_ctx.resetLabel), 1 /* TEXT */)]),
      _: 1 /* STABLE */
    })], 2 /* CLASS */)])]),
    default: withCtx(() => [createElementVNode("div", mergeProps(_ctx.$attrs, {
      ref: 'root',
      class: _ctx.rootStyles
    }), [renderSlot(_ctx.$slots, "default")], 16 /* FULL_PROPS */)]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["is-open"])) : createCommentVNode("v-if", true)]);
}

script.render = render;
script.__file = "src/components/or-filter-popover-v3/OrFilterPopover.vue";

export { script as OrFilterPopoverV3 };
